import { CONNECTIVITY_TARGET } from "../const/connectivity"

export const isConnectivityTargetMet = (connected: number, disconnected: number) =>
  connected >= (connected + disconnected) * CONNECTIVITY_TARGET
